import { render } from "./UploadAsset.vue?vue&type=template&id=41b78933"
import script from "./UploadAsset.vue?vue&type=script&lang=js"
export * from "./UploadAsset.vue?vue&type=script&lang=js"

import "./UploadAsset.vue?vue&type=style&index=0&id=41b78933&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__